import { render, staticRenderFns } from "./SpreadSheetB2B.vue?vue&type=template&id=40664a74&scoped=true"
import script from "./SpreadSheetB2B.vue?vue&type=script&lang=ts"
export * from "./SpreadSheetB2B.vue?vue&type=script&lang=ts"
import style0 from "./SpreadSheet.scss?vue&type=style&index=0&id=40664a74&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40664a74",
  null
  
)

export default component.exports